import { render, staticRenderFns } from "./TabControl.vue?vue&type=template&id=4368b89d&"
import script from "./TabControl.vue?vue&type=script&lang=ts&"
export * from "./TabControl.vue?vue&type=script&lang=ts&"
import style0 from "./TabControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports